import axios from 'axios';
import Cookies from 'js-cookie';
import {store} from "./store";


export const setupAxios = () => {
    const state = store.getState();
    const backEndUrl = state.search.backEndUrl;
    axios.defaults.baseURL = backEndUrl;

    axios.interceptors.request.use((config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });
};
